import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { ROUTES } from '../app.routes';
import { RouterModule, PreloadAllModules } from '@angular/router';

import { TooltipModule } from 'primeng/tooltip';
import { PanelModule } from 'primeng/panel';
import { InputTextModule } from 'primeng/inputtext';
import { FieldsetModule } from 'primeng/fieldset';
import { RatingModule } from 'primeng/rating';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { DataViewModule } from 'primeng/dataview';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DialogModule } from 'primeng/dialog';


@NgModule({
    imports: [ // import Angular's modules
        BrowserModule,
        RouterModule.forRoot(ROUTES, { useHash: true, preloadingStrategy: PreloadAllModules }),
        TooltipModule,
        PanelModule,
        InputTextModule,
        FieldsetModule,
        RatingModule,
        FormsModule,
        CalendarModule,
        DropdownModule,
        DataViewModule,
        RadioButtonModule,
        CheckboxModule,
        InputTextareaModule,
        DialogModule,
    ],
    declarations: [
    ],
    exports: [
    ]
})
export class UtilsModule { }